export default __webpack_public_path__ + "static/kenneth_bw-1cd8e676cbd31aacb1ec66fc5403adfe.jpeg";